module.exports = __webpack_public_path__ + "img/removals-es.bb5054b.webp";